<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("overtimeAddTxt") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row">
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("customerId_txt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchCompany"
                            return-object
                            label="customer_id"
                            v-model="forms.customer_id"
                            @search="asyncSearchCompany"
                            :reduce="(option) => option.customer_id"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.customer_id }} - {{ option.name }}
                            </template>
                          </v-select>

                          <div v-if="errors.customer_id">
                            <div
                              v-for="error in errors.customer_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("fulfillment_code") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchWarehouse"
                            return-object
                            required
                            label="warehouse_id"
                            v-model="forms.warehouse_id"
                            @search="asyncSearchWarehouse"
                            :reduce="(option) => option.warehouse_id"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.warehouse_id }} - {{ option.name }}
                            </template>
                          </v-select>
                          <div v-if="errors.warehouse_id">
                            <div
                              v-for="error in errors.warehouse_id"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("employeeIdTxt") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchEmployee"
                            return-object
                            required
                            label="id_employee"
                            v-model="selectedEmployee"
                            @search="asyncSearchEmployee"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.id_employee }} - {{ option.name }}
                            </template>
                          </v-select>
                          <div v-if="errors.id_employee">
                            <div
                              v-for="error in errors.id_employee"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("overtimeCostId") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchCostOvertime"
                            return-object
                            required
                            label="code"
                            v-model="selectedCostOvertime"
                            :disabled="enableEmploye"
                            @search="asyncSearchCostOvertime"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.code }} - {{ option.description }}
                            </template>
                          </v-select>
                          <div v-if="errors.cost_center_overtime_code">
                            <div
                              v-for="error in errors.cost_center_overtime_code"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div> -->

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("overtimeType") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchTypeOvertime"
                            return-object
                            required
                            label="description"
                            v-model="selectedTypeOvertime"
                          ></v-select>
                          <div v-if="errors.ot_type">
                            <div
                              v-for="error in errors.ot_type"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("totalWorkDay") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <v-select
                            :options="fetchWorkDays"
                            return-object
                            required
                            label="description"
                            v-model="selectedWorkDays"
                          ></v-select>
                          <div v-if="errors.amount_of_work">
                            <div
                              v-for="error in errors.amount_of_work"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("overtimeDateTxt") }}</label
                              >
                            </div>
                            <div class="col-lg-7">
                              <date-picker
                                v-model="forms.ot_date"
                                input-class="form-control"
                                placeholder="YYYY-MM-DD"
                                format="YYYY-MM-DD"
                                value-type="format"
                                type="date"                                
                                required
                                @input="clearDate"
                              ></date-picker>

                              <div v-if="errors.ot_date">
                                <div
                                  v-for="error in errors.ot_date"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("breakTime") }}</label
                              >
                            </div>
                            <div class="col-lg-6">
                              <input
                                type="number"
                                class="form-control"
                                v-model="forms.break_value"
                                required
                              />

                              <div v-if="errors.break_value">
                                <div
                                  v-for="error in errors.break_value"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("startOvertime") }}</label
                              >
                            </div>
                            <div class="col-lg-7">
                              <!-- format="HH:00"
                                value-type="format" -->
                              <date-picker
                                v-model="forms.value_start"
                                input-class="form-control"
                                type="datetime"
                                :disabled="
                                  forms.ot_date == '' || forms.ot_date == null
                                "
                                format="YYYY-MM-DD HH:mm"
                                value-type="format"
                                placeholder="Input Overtime Start"
                                :minute-step="30"
                                :disabled-date="disabledOvertimeStart"
                                :disabled-time="disableOvertimeStartHour"
                                required
                                @input="clearEndOvertime"
                              ></date-picker>

                              <div v-if="errors.ot_value_start">
                                <div
                                  v-for="error in errors.ot_value_start"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="row">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("endOvertime") }}</label
                              >
                            </div>
                            <div class="col-lg-7">
                              <date-picker
                                v-model="forms.value_end"
                                input-class="form-control"
                                type="datetime"
                                format="YYYY-MM-DD HH:mm"
                                value-type="format"
                                placeholder="Input Overtime End"
                                required
                                :disabled-time="disabledOvertimeEndHour"
                                :disabled-date="disabledOvertimeEndDate"
                                :minute-step="30"
                                :disabled="
                                  forms.value_start == '' ||
                                  forms.value_start == null
                                "
                              ></date-picker>

                              <div v-if="errors.ot_value_end">
                                <div
                                  v-for="error in errors.ot_value_end"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-5">
                          <div class="row mb-3">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("overtimeType") }}</label
                              >
                            </div>
                            <div class="col-lg-7">
                              <v-select
                                :options="[
                                  { label: 'Internal', code: 'internal' },
                                  { label: 'External', code: 'external' },
                                ]"
                                :reduce="(val) => val.code"
                                label="label"
                                required
                                v-model="forms.type_data"
                              ></v-select>
                            </div>
                          </div>
                        </div>
                        <div class="col-5">
                          <div class="row mb-3">
                            <div class="col-lg-5">
                              <label
                                for="defaultconfig"
                                class="col-form-label"
                                style="padding-left: 25px"
                                >{{ $t("actualOvertime") }}</label
                              >
                            </div>
                            <div class="col-lg-7">
                              <v-select
                                :options="[
                                  { label: 'Yes', code: 1 },
                                  { label: 'No', code: 0 },
                                ]"
                                :reduce="(val) => val.code"
                                label="label"
                                required
                                v-model="forms.is_actual_overtime"
                              ></v-select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("keterangan") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <textarea
                            name="catatan"
                            class="form-control"
                            v-model="forms.catatan"
                          ></textarea>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label
                            for="defaultconfig"
                            class="col-form-label"
                            style="padding-left: 25px"
                            >{{ $t("splImages") }}</label
                          >
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="file"
                            ref="fileUpload"
                            @change="handleFileUpload($event)"
                            class="form-control"
                          />
                          <div
                            v-show="imgSrc !== '' || imgSrc !== null"
                            class="mt-3"
                          >
                            <img
                              :src="imgSrc"
                              style="
                                max-height: 100px;
                                cursor: pointer;
                                width: auto;
                              "
                              @click="
                                visible = true;
                                imageIndex = 1;
                              "
                            />
                          </div>
                          <div v-if="errors.spl_image">
                            <div></div>
                            <div
                              v-for="error in errors.spl_image"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <vue-easy-lightbox
          escDisabled
          moveDisabled
          :visible="visible"
          :imgs="imgSrc"
          :index="imageIndex"
          @hide="handleHide"
        ></vue-easy-lightbox>

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/id";
import VueEasyLightbox from "vue-easy-lightbox";
import moment from "moment";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "OvertimeAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DatePicker,
    // vueDropzone: vue2Dropzone,
    VueEasyLightbox,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      forms: {
        break_value: 0,
        is_actual_overtime: 1,
        type_data: "internal",
      },
      fetchWarehouse: [],
      fetchCompany: [],
      fetchEmployee: [],
      selectedEmployee: null,
      fetchTypeOvertime: [],
      selectedTypeOvertime: null,
      fetchWorkDays: [],
      selectedWorkDays: null,
      fetchCostOvertime: [],
      selectedCostOvertime: null,
      enableEmploye: true,

      imgs: null,
      imageIndex: 0,
      visible: false,
      file: "",
      imgSrc: "",
    };
  },
  computed: {},
  methods: {
    calcEndOvertimeStart() {
      let d = new Date();
      if (this.forms?.value_start) {
        d = new Date(this.forms.value_start);
        d.setHours(d.getHours() + 1);
      }
      return d;
    },
    calcEndOvertimeEnd() {
      let d = new Date();
      if (this.forms?.value_start) {
        d = new Date(this.forms.value_start);
        d.setHours(d.getHours() + 12);
      }
      return d;
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.imgSrc = URL.createObjectURL(this.file);
    },
    removeFile() {
      this.images = this.$refs.myVueDropzone.getAcceptedFiles();
      console.log(this.images);
      this.imgs = this.$refs.myVueDropzone.getAcceptedFiles().map((file) => {
        return URL.createObjectURL(file);
      });
    },
    handleHide() {
      this.visible = false;
    },
    handleCustomButtonClick(file, index) {
      // console.log('Custom button clicked for file:', file.name, 'index:', index);
      // // Implement your custom logic here, e.g., open a modal, apply a filter, etc.
      // alert(`Custom button clicked for ${file.name}`);

      this.imageIndex = index;
      this.visible = true;
    },
    disabledBeforeToday(date) {
      const now = new Date();
      now.setDate(now.getDate() - 3);
      now.setHours(0, 0, 0, 0);
      return date < now;
    },

    disabledHourBeforeNow(date) {
      const now = new Date();
      let hour = now.getHours() + 1;

      if (this.forms?.ot_date) {
        const selectedDate = new Date(this.forms.ot_date);
        if (selectedDate.getDate() > now.getDate()) {
          hour = 0;
        }
      }

      return date.getHours() < hour;
    },
    clearDate() {
      this.$delete(this.forms, "value_start");
      this.$delete(this.forms, "value_end");
    },
    clearEndOvertime() {
      this.$delete(this.forms, "value_end");
    },
    disabledOvertimeStart(date) {
      let startDate = new Date();
      let endDate = new Date();
      if (this.forms?.ot_date) {
        startDate = new Date(this.forms.ot_date);
        startDate.setHours(0, 0, 0, 0);

        endDate.setDate(startDate.getDate() + 1);
      }

      return date < startDate || date > endDate;

      // return (
      //   date.getFullYear() !== selectedDate.getFullYear() ||
      //   date.getMonth() !== selectedDate.getMonth() ||
      //   date.getDate() !== selectedDate.getDate()
      // );
    },

    disabledOvertimeEndDate(date) {
      const ot_date = new Date(this.forms.ot_date);
      const start_ot = new Date(this.forms.value_start);

      const t = date.getTime();
      if (ot_date.getDate() !== start_ot.getDate()) {
        return date.getDate() !== start_ot.getDate();
      } else {
        return (
          t < this.calcEndOvertimeStart().setHours(0, 0, 0, 0) ||
          t > this.calcEndOvertimeEnd().setHours(0, 0, 0, 0)
        );
      }
    },

    // Disable time by comparing against startTime and endTime
    disabledOvertimeEndHour(date) {
      const isStart =
        date.toDateString() === this.calcEndOvertimeStart().toDateString();
      const isEnd =
        date.toDateString() === this.calcEndOvertimeEnd().toDateString();

      // Debug
      // console.table([
      //   { a: "Raw Date", b: date },
      //   { a: "Convert Date", b: date.toISOString() },
      //   { a: "Hour", b: date.getHours() },
      //   { a: "Is Selected Start", b: isStart ? "Iya" : "Tidak"},
      //   { a: "Is Selected End", b: isEnd ? "Iya" : "Tidak"},
      //   { a: "Start Raw", b: this.calcEndOvertimeStart()},
      //   { a: "Start Convert", b: this.calcEndOvertimeStart().toISOString()},
      //   { a: "End Convert", b: this.calcEndOvertimeEnd()},
      //   { a: "End Raw", b: this.calcEndOvertimeEnd().toISOString()},
      //   { a: "Start Hour", b: this.calcEndOvertimeStart().getHours()},
      //   { a: "End Hour", b: this.calcEndOvertimeEnd().getHours()},
      //   { a: "Condition 1", b: (isStart && date.getHours() < this.calcEndOvertimeStart().getHours()) },
      //   { a: "Condition 2", b: (isEnd && date.getHours() > this.calcEndOvertimeEnd().getHours())},

      // ])
      return (
        (isStart && date.getHours() < this.calcEndOvertimeStart().getHours()) ||
        (isEnd && date.getHours() > this.calcEndOvertimeEnd().getHours())
      );
    },
    disableOvertimeStartHour(date) {
      const ot_date = new Date(this.forms.ot_date);
      const isSamedate = date.getDate() == ot_date.getDate();

      /* Disabled Date If Selected Date <> OT Date and allow to pick only until 10 AM */
      return !isSamedate ? date.getHours() > 10 : false;
    },

    loadWarehouse() {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/list-warehouse?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    asyncSearchWarehouse(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/index?status=active&warehouse_id=" +
        ev;
      this.fetchWarehouse = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadCompany() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/customer/index?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchCompany(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/customer/index?status=active&warehouse_id=" +
        ev;
      this.fetchCompany = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadEmployee() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/employee/index?status=active";

      this.selectedEmployee = null;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchEmployee = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchEmployee(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/employee/index?status=active&search=" +
        ev;

      this.fetchEmployee = [];

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchEmployee = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadCostOvertime() {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/cost-center-overtime/index?status=active&warehouse_id=" +
        this.forms.warehouse_id +
        "&customer_id=" +
        this.forms.customer_id;

      this.selectedCostOvertime = null;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCostOvertime = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchCostOvertime(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/cost-center-overtime/index?status=active&warehouse_id=" +
        this.forms.warehouse_id +
        "&customer_id=" +
        this.forms.customer_id +
        "&name=" +
        ev;

      this.fetchCostOvertime = [];

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCostOvertime = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadTypeOvertime() {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/system-code/index?code=ot_type&status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchTypeOvertime = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadWorkDays() {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/system-code/index?code=ot_of_work&status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWorkDays = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    resetForm() {
      this.forms = {};
    },

    backForm() {
      window.location.href = "/wh-monitoring/overtime";
    },

    submitData() {
      this.fade(true);

      let forms = this.forms;
      if (this.selectedEmployee !== null) {
        forms.id_employee = this.selectedEmployee.id_employee;
        forms.name_employee = this.selectedEmployee.name;
        forms.status_employee = this.selectedEmployee.status_employee;
        forms.posisition_employee = this.selectedEmployee.posisition;
        forms.level_employee = this.selectedEmployee.level;
        forms.division_employee = this.selectedEmployee.division;
      }
      if (this.selectedTypeOvertime !== null) {
        forms.ot_type = this.selectedTypeOvertime.value;
        forms.ot_type_desc = this.selectedTypeOvertime.description;
      }
      if (this.selectedCostOvertime !== null) {
        forms.cost_center_overtime_code = this.selectedCostOvertime.code;
        forms.cost_center_overtime_description =
          this.selectedCostOvertime.description;
      }

      if (this.selectedWorkDays !== null) {
        forms.amount_of_work = this.selectedWorkDays.value;
        forms.amount_of_work_description = this.selectedWorkDays.description;
      }
      if (
        this.forms.value_start !== null &&
        this.forms.value_start !== undefined &&
        this.forms.value_start !== ""
      ) {
        // let start = this.forms.value_start.split(":");
        forms.ot_value_start = moment(String(this.forms.value_start)).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        // forms.ot_value_start = this.forms.value_start;
      }
      if (
        this.forms.value_end !== null &&
        this.forms.value_end !== undefined &&
        this.forms.value_end !== ""
      ) {
        forms.ot_value_end = moment(String(this.forms.value_end)).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/overtime/create";

      let formData = new FormData();
      for (let key in forms) {
        if (forms[key] === null || forms[key] === undefined) {
          forms[key] = "";
        }
        formData.append(key, forms[key]);
      }

      formData.append("spl_image", this.file);
      this.$http
        .post(baseURI, formData, { timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];
            this.loading();
            var params = this.$onRandom(response.data.datas.overtime_id);
            window.location.href =
              "/wh-monitoring/overtime/detail/" +
              params +
              "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
            this.loading();
          }
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
          this.loading();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      this.companyCode = this.detailUser.company_detail.code;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller == "WhMonitoringOvertimeController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadCompany();
    this.loadWarehouse();
    this.loadTypeOvertime();
    this.loadWorkDays();
    this.loadEmployee();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
  pointer-events: none;
}
</style>
